import React from 'react';
import SubjectPage from '../structure/SubjectPage';

const ML_CSE = () => {
    const accordionContent = [
        <div key="1" className="p-4">
            <p>ntroduction: Machine learning, terminologies in machine learning, Perspectives and issues in machine
                learning, application of Machine learning, Types of machine learning: supervised, unsupervised, semi-
                supervised learning. Review of probability, Basic Linear Algebra in Machine Learning Techniques, Dataset and
                its types,Data preprocessing, Bias and Variance in Machine learning , Function approximation, Overfitting</p>
        </div>,
        <div key="2" className="p-4">
            <p>Regression Analysis in Machine Learning: Introduction to regression and its terminologies,Types of
                regression,Logistic Regression Simple Linear regression: Introduction to Simple Linear Regression and its assumption, Simple Linear
                Regression Model Building,Ordinary Least square estimation, Properties of the least-squares estimators and
                the fitted regression model, Interval estimation in simple linear regression , Residuals
                Multiple Linear Regression:Multiple linear regression model and its assumption, Interpret Multiple Linear
                Regression Output(R-Square, Standard error, F, Significance F, Cofficient P values), Access the fit of multiple
                linear regression model (R squared, Standard error)
                Feature Selection and Dimensionality Reduction: PCA, LDA, ICA</p>
        </div>,
        <div key="3" className="p-4">
            <p>Introduction to Classification and Classification Algorithms: What is Classification? General Approach to
                Classification, k-Nearest Neighbor Algorithm, Random Forests, Fuzzy Set Approaches
                Support Vector Machine: Introduction, Types of support vector kernel – (Linear kernel, polynomial kernel, and
                Gaussiankernel), Hyperplane – (Decision surface), Properties of SVM, and Issues in SVM.
                Decision Trees: Decision tree learning algorithm,ID-3algorithm, Inductive bias, Entropy and information
                theory, Information gain,Issues in Decision tree learning.
                Bayesian Learning - Bayes theorem, Concept learning, Bayes Optimal Classifier, Naïve Bayes classifier,
                Bayesian belief networks, EM algorithm
                Ensemble Methods: Bagging, Boosting and AdaBoost and XBoost,
                Classification Model Evaluation and Selection: Sensitivity, Specificity, Positive Predictive Value, Negative
                Predictive Value, Lift Curves and Gain Curves, ROC Curves, Misclassification Cost Adjustment to Reflect Real-
                World Concerns, Decision Cost/Benefit Analysis</p>
        </div>,
        <div key="4" className="p-4">
            <p>Introduction to Cluster Analysis and Clustering Methods: The Clustering Task and the Requirements for
                Cluster Analysis , Overview of Some Basic Clustering Methods:-k-Means Clustering, k-Medoids Clustering,
                Density-Based Clustering: DBSCAN - Density-Based Clustering Based on Connected Regions with High Density,
                Gaussian Mixture Model algorithm , Balance Iterative Reducing and Clustering using Hierarchies (BIRCH) ,
                Affinity Propagation clustering algorithm,Mean-Shift clustering algorithm, ordering Points to Identify the
                Clustering Structure (OPTICS) algorithm, Agglomerative Hierarchy clustering algorithm, Divisive Hierarchical ,
                Measuring Clustering Goodness</p>
        </div>
    ];

    const tabData = [
        {
            id: 'syllabus',
            label: 'Syllabus',
            content: null, // Will be replaced in SubjectPage
        },
        {
            id: 'notes',
            label: 'Notes',
            content: null, // Will be replaced in SubjectPage
        },
        {
            id: 'important',
            label: 'Important Questions',
            content: null, // Will be replaced in SubjectPage
        },
        {
            id: 'books',
            label: 'Books',
            content: null, // Will be replaced in SubjectPage
        },
        {
            id: 'PYQ',
            label: 'PYQ',
            content: null, // Will be replaced in SubjectPage
        },
        {
            id: 'youtube_playlist',
            label: 'Video Lectures',
            content: null, // Will be replaced in SubjectPage
        },
    ];

    return (
        <SubjectPage
            subjectName="Machine Learning"
            subjectKey="ML_CSE"
            accordionContent={accordionContent}
            tabData={tabData}
            adminEmail="snaped4338@gmail.com"
            firestoreCollections={{
                notes: 'ML_CSENotes',
                videos: 'ML_CSEVideos'
            }}
        />
    );
};

export default ML_CSE;